import { zillowRequester } from './requester';

const api = {
  user: {
    info(params) {
      return zillowRequester({
        method: 'get',
        endpoint: 'renter-hub-api/api/v1/users/get',
        queryParams: params,
      });
    },
  },
  // move-in-survey
  moveInFeedback: {
    submitFeedback(body) {
      return zillowRequester({
        method: 'post',
        endpoint: `renter-hub-api/api/v1/users/inquiryFeedback/submitLeaseDetails`,
        body,
      });
    },
    getListingsByRenterId(renterId, latestInquiredDateInMillis) {
      return zillowRequester({
        method: 'get',
        // TODO
        endpoint: `renter-hub-api/api/v1/users/inquiryFeedback/getListingsByRenterId`,
        queryParams: {
          renterId,
          latestInquiredDateInMillis,
        },
      });
    },
  },
  // autocomplete address
  address: {
    autocomplete(partialAddress) {
      return zillowRequester({
        method: 'get',
        endpoint: 'renter-hub-api/api/v1/addresses/autocomplete',
        queryParams: {
          partialAddress,
        },
        timeout: 5000,
      });
    },
  },
  payments: {
    fetchPaymentInfo() {
      return zillowRequester({
        method: 'post',
        endpoint: 'renter-hub-api/api/v2/users/rentPayment/getRenterStatus',
        preparse: false,
      });
    },
  },
  waitlistConfirmation: {
    confirmWaitlist(leadId, hash, sendEmail) {
      return zillowRequester({
        method: 'post',
        endpoint: 'renter-hub-api/api/v1/waitlistConfirmation',
        queryParams: {
          leadId,
          hash,
          sendEmail,
        },
      });
    },
  },
  debug: {
    ipDetection() {
      return zillowRequester({
        method: 'get',
        endpoint: 'renter-hub-api/datarouter/ipDetection',
      });
    },
    triggerException() {
      return zillowRequester({
        method: 'get',
        endpoint: 'renter-hub-api/datarouter/errorGenerator',
      });
    },
  },
};

export default api;
